export const initialMonthlyBudget = {
    budget_month_1: "",
    budget_month_2: "",
    budget_month_3: "",
    budget_month_4: "",
    budget_month_5: "",
    budget_month_6: "",
    budget_month_7: "",
    budget_month_8: "",
    budget_month_9: "",
    budget_month_10: "",
    budget_month_11: "",
    budget_month_12: "",
};
